import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function MemberCard() {
  const navigate = useNavigate();
  const userEmail =
    localStorage.getItem("userEmail") || "member@ucstudycoffee.com";
  const userRole = localStorage.getItem("userRole") || "customer";

  // Get userName from localStorage, or extract from email as fallback
  let userName = localStorage.getItem("userName");
  if (!userName || userName === "MEMBER NAME") {
    // Extract name from email
    const emailName = userEmail.split("@")[0];
    userName = emailName.replace(/\./g, " ").toUpperCase();

    // If it's a demo account, set proper name
    if (userEmail === "customer@uc.vn") {
      userName = "Nguyen Van A";
      localStorage.setItem("userName", userName);
    } else if (userEmail === "admin@uc.vn") {
      userName = "Admin UC";
      localStorage.setItem("userName", userName);
    } else if (userEmail === "staff@uc.vn") {
      userName = "Staff Member";
      localStorage.setItem("userName", userName);
    }
  }

  const accountCreated =
    localStorage.getItem("accountCreated") || new Date().toISOString();

  // Calculate points (mock data - could come from API)
  const [points, setPoints] = useState(0);

  useEffect(() => {
    // Mock: Generate points based on email hash
    let hash = 0;
    for (let i = 0; i < userEmail.length; i++) {
      hash = (hash << 5) - hash + userEmail.charCodeAt(i);
    }
    const mockPoints = Math.abs(hash) % 10000; // 0-9999 points
    setPoints(mockPoints);
  }, [userEmail]);

  // Generate member ID based on email hash
  const generateMemberId = (email) => {
    let hash = 0;
    for (let i = 0; i < email.length; i++) {
      hash = (hash << 5) - hash + email.charCodeAt(i);
      hash = hash & hash;
    }
    const id = Math.abs(hash).toString().padStart(16, "0");
    return `${id.slice(0, 4)} ${id.slice(4, 8)} ${id.slice(8, 12)} ${id.slice(
      12,
      16
    )}`;
  };

  const memberId = generateMemberId(userEmail);

  // Get member tier based on role
  const memberTier = userRole === "admin" ? "PLATINUM" : "GOLD";

  // Account created date
  const createdDate = new Date(accountCreated);

  const [isFlipped, setIsFlipped] = useState(false);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        paddingTop: "100px",
        paddingBottom: "100px",
      }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col lg={10}>
            <div className="text-center text-white mb-5">
              <h1 className="display-4 fw-bold mb-3">
                <i className="bi bi-credit-card-2-front me-3"></i>
                Thẻ Hội Viên UC Study Coffee
              </h1>
              <p className="lead opacity-90">
                Thẻ thành viên độc quyền dành cho bạn
              </p>
              <div className="mt-4">
                <div
                  className="d-inline-block px-5 py-3 rounded-pill"
                  style={{
                    background: "rgba(255,255,255,0.2)",
                    backdropFilter: "blur(10px)",
                    border: "2px solid rgba(255,255,255,0.3)",
                  }}
                >
                  <div className="d-flex align-items-center gap-3">
                    <i
                      className="bi bi-star-fill"
                      style={{ fontSize: "32px", color: "#ffd700" }}
                    ></i>
                    <div className="text-start">
                      <div className="small opacity-75">Điểm tích lũy</div>
                      <div className="fs-2 fw-bold">
                        {points.toLocaleString()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Card 3D Flip Container */}
            <div
              style={{
                perspective: "1000px",
                marginBottom: "40px",
              }}
            >
              <div
                onClick={() => setIsFlipped(!isFlipped)}
                style={{
                  position: "relative",
                  width: "100%",
                  maxWidth: "500px",
                  margin: "0 auto",
                  height: "320px",
                  transformStyle: "preserve-3d",
                  transition: "transform 0.8s",
                  transform: isFlipped ? "rotateY(180deg)" : "rotateY(0)",
                  cursor: "pointer",
                }}
              >
                {/* Front Side */}
                <div
                  style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    backfaceVisibility: "hidden",
                    borderRadius: "20px",
                    background:
                      "linear-gradient(135deg, #1e3c72 0%, #2a5298 50%, #7e22ce 100%)",
                    padding: "30px",
                    boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
                    overflow: "hidden",
                  }}
                >
                  {/* Decorative Pattern */}
                  <div
                    style={{
                      position: "absolute",
                      top: "-50%",
                      right: "-20%",
                      width: "400px",
                      height: "400px",
                      background:
                        "linear-gradient(45deg, rgba(255,255,255,0.1), transparent)",
                      borderRadius: "50%",
                      transform: "rotate(-30deg)",
                    }}
                  ></div>
                  <div
                    style={{
                      position: "absolute",
                      bottom: "-30%",
                      left: "-10%",
                      width: "300px",
                      height: "300px",
                      background:
                        "linear-gradient(-45deg, rgba(255,255,255,0.05), transparent)",
                      borderRadius: "50%",
                    }}
                  ></div>

                  {/* Red Circuit Lines Pattern */}
                  <svg
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      opacity: 0.3,
                    }}
                  >
                    <line
                      x1="0"
                      y1="50"
                      x2="500"
                      y2="50"
                      stroke="#dc2626"
                      strokeWidth="2"
                    />
                    <line
                      x1="100"
                      y1="0"
                      x2="100"
                      y2="320"
                      stroke="#dc2626"
                      strokeWidth="2"
                    />
                    <line
                      x1="200"
                      y1="100"
                      x2="500"
                      y2="100"
                      stroke="#dc2626"
                      strokeWidth="2"
                    />
                    <line
                      x1="300"
                      y1="0"
                      x2="300"
                      y2="200"
                      stroke="#dc2626"
                      strokeWidth="2"
                    />
                    <line
                      x1="0"
                      y1="150"
                      x2="400"
                      y2="150"
                      stroke="#dc2626"
                      strokeWidth="2"
                      strokeDasharray="5,5"
                    />
                  </svg>

                  {/* Chip */}
                  <div
                    style={{
                      width: "60px",
                      height: "45px",
                      background: "linear-gradient(135deg, #ffd700, #ffed4e)",
                      borderRadius: "8px",
                      position: "relative",
                      marginBottom: "30px",
                      boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: "8px",
                        left: "8px",
                        right: "8px",
                        bottom: "8px",
                        border: "1px solid #daa520",
                        borderRadius: "4px",
                      }}
                    >
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "repeat(3, 1fr)",
                          gap: "3px",
                          padding: "4px",
                        }}
                      >
                        {[...Array(9)].map((_, i) => (
                          <div
                            key={i}
                            style={{
                              width: "4px",
                              height: "4px",
                              background: "#daa520",
                              borderRadius: "50%",
                            }}
                          ></div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* UC Logo */}
                  <div
                    style={{
                      position: "absolute",
                      top: "30px",
                      right: "30px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                      gap: "8px",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "28px",
                        fontWeight: "bold",
                        color: "white",
                        textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
                        letterSpacing: "2px",
                      }}
                    >
                      UC{memberTier}
                    </div>
                    <div
                      style={{
                        fontSize: "11px",
                        color: "rgba(255,255,255,0.8)",
                        letterSpacing: "1px",
                      }}
                    >
                      MEMBER SINCE {createdDate.getFullYear()}
                    </div>
                  </div>

                  {/* Card Number */}
                  <div
                    style={{
                      fontSize: "26px",
                      letterSpacing: "4px",
                      color: "white",
                      fontFamily: "Courier New, monospace",
                      fontWeight: "bold",
                      marginBottom: "30px",
                      textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
                      position: "relative",
                      zIndex: 1,
                    }}
                  >
                    {memberId}
                  </div>

                  {/* Card Holder */}
                  <div
                    style={{
                      position: "relative",
                      zIndex: 1,
                    }}
                  >
                    <div
                      style={{
                        fontSize: "10px",
                        color: "rgba(255,255,255,0.7)",
                        marginBottom: "5px",
                        textTransform: "uppercase",
                        letterSpacing: "1px",
                      }}
                    >
                      Card Holder
                    </div>
                    <div
                      style={{
                        fontSize: "18px",
                        color: "white",
                        fontWeight: "bold",
                        textTransform: "uppercase",
                        letterSpacing: "2px",
                        textShadow: "1px 1px 2px rgba(0,0,0,0.3)",
                      }}
                    >
                      {userName.toUpperCase()}
                    </div>
                  </div>

                  {/* Brand Logo */}
                  <div
                    style={{
                      position: "absolute",
                      bottom: "20px",
                      right: "30px",
                      fontSize: "14px",
                      color: "white",
                      fontWeight: "bold",
                      fontStyle: "italic",
                      opacity: 0.9,
                      textShadow: "1px 1px 2px rgba(0,0,0,0.3)",
                    }}
                  >
                    <i className="bi bi-cup-hot-fill me-2"></i>
                    STUDY COFFEE
                  </div>
                </div>

                {/* Back Side */}
                <div
                  style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    backfaceVisibility: "hidden",
                    transform: "rotateY(180deg)",
                    borderRadius: "20px",
                    background:
                      "linear-gradient(135deg, #1e3c72 0%, #2a5298 50%, #7e22ce 100%)",
                    boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
                    overflow: "hidden",
                  }}
                >
                  {/* Magnetic Stripe */}
                  <div
                    style={{
                      width: "100%",
                      height: "60px",
                      background: "#1a1a1a",
                      marginTop: "40px",
                      marginBottom: "30px",
                    }}
                  ></div>

                  {/* Signature Strip */}
                  <div style={{ padding: "0 30px" }}>
                    <div
                      style={{
                        background: "white",
                        height: "50px",
                        borderRadius: "8px",
                        marginBottom: "20px",
                        position: "relative",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          fontFamily: "Brush Script MT, cursive",
                          fontSize: "24px",
                          color: "#333",
                          fontStyle: "italic",
                        }}
                      >
                        {userName.split(" ")[0]}
                      </div>
                    </div>

                    {/* QR Code */}
                    <div style={{ textAlign: "center", marginTop: "20px" }}>
                      <div
                        style={{
                          width: "100px",
                          height: "100px",
                          background: "white",
                          margin: "0 auto",
                          borderRadius: "10px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "60px",
                        }}
                      >
                        <i className="bi bi-qr-code"></i>
                      </div>
                      <p
                        style={{
                          color: "white",
                          fontSize: "12px",
                          marginTop: "10px",
                          opacity: 0.8,
                        }}
                      >
                        Scan để tích điểm
                      </p>
                    </div>
                  </div>

                  {/* Customer Service */}
                  <div
                    style={{
                      position: "absolute",
                      bottom: "20px",
                      left: "30px",
                      right: "30px",
                      color: "rgba(255,255,255,0.8)",
                      fontSize: "11px",
                      textAlign: "center",
                    }}
                  >
                    Hotline: 1900 1234 | www.ucstudycoffee.com
                  </div>
                </div>
              </div>
            </div>

            {/* Flip Instruction */}
            <div className="text-center text-white mb-5">
              <p className="opacity-75">
                <i className="bi bi-hand-index-thumb me-2"></i>
                Nhấn vào thẻ để xem mặt sau
              </p>
            </div>

            {/* Member Benefits */}
            <Row className="g-4 mb-5">
              <Col md={3}>
                <Card
                  className="border-0 shadow-lg h-100"
                  style={{
                    borderRadius: "20px",
                    background: "rgba(255,255,255,0.95)",
                  }}
                >
                  <Card.Body className="p-4 text-center">
                    <div
                      className="mb-3"
                      style={{
                        width: "70px",
                        height: "70px",
                        background: "linear-gradient(135deg, #ffd700, #ff8c00)",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto",
                        fontSize: "32px",
                        color: "white",
                      }}
                    >
                      <i className="bi bi-star-fill"></i>
                    </div>
                    <h5 className="fw-bold mb-2">{points.toLocaleString()}</h5>
                    <p className="text-muted mb-0 small">
                      Điểm tích lũy hiện tại
                    </p>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={3}>
                <Card
                  className="border-0 shadow-lg h-100"
                  style={{
                    borderRadius: "20px",
                    background: "rgba(255,255,255,0.95)",
                  }}
                >
                  <Card.Body className="p-4 text-center">
                    <div
                      className="mb-3"
                      style={{
                        width: "70px",
                        height: "70px",
                        background: "linear-gradient(135deg, #667eea, #764ba2)",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto",
                        fontSize: "32px",
                        color: "white",
                      }}
                    >
                      <i className="bi bi-percent"></i>
                    </div>
                    <h5 className="fw-bold mb-2">Giảm Giá 15%</h5>
                    <p className="text-muted mb-0 small">
                      Tất cả đồ uống & dịch vụ
                    </p>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={3}>
                <Card
                  className="border-0 shadow-lg h-100"
                  style={{
                    borderRadius: "20px",
                    background: "rgba(255,255,255,0.95)",
                  }}
                >
                  <Card.Body className="p-4 text-center">
                    <div
                      className="mb-3"
                      style={{
                        width: "70px",
                        height: "70px",
                        background: "linear-gradient(135deg, #667eea, #764ba2)",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto",
                        fontSize: "32px",
                        color: "white",
                      }}
                    >
                      <i className="bi bi-calendar-check"></i>
                    </div>
                    <h5 className="fw-bold mb-2">Ưu Tiên Đặt Chỗ</h5>
                    <p className="text-muted mb-0 small">
                      Giữ chỗ giờ cao điểm
                    </p>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={3}>
                <Card
                  className="border-0 shadow-lg h-100"
                  style={{
                    borderRadius: "20px",
                    background: "rgba(255,255,255,0.95)",
                  }}
                >
                  <Card.Body className="p-4 text-center">
                    <div
                      className="mb-3"
                      style={{
                        width: "70px",
                        height: "70px",
                        background: "linear-gradient(135deg, #667eea, #764ba2)",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto",
                        fontSize: "32px",
                        color: "white",
                      }}
                    >
                      <i className="bi bi-gift-fill"></i>
                    </div>
                    <h5 className="fw-bold mb-2">Đổi Quà</h5>
                    <p className="text-muted mb-0 small">100K = 1 điểm</p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            {/* Action Buttons */}
            <div className="text-center">
              <Button
                size="lg"
                onClick={() => navigate("/booking")}
                className="me-3 px-5 py-3 fw-semibold border-0"
                style={{
                  background: "white",
                  color: "#667eea",
                  borderRadius: "50px",
                }}
              >
                <i className="bi bi-calendar-check me-2"></i>
                Đặt Chỗ Ngay
              </Button>
              <Button
                variant="outline-light"
                size="lg"
                onClick={() => navigate("/")}
                className="px-5 py-3 fw-semibold"
                style={{
                  borderRadius: "50px",
                  borderWidth: "2px",
                }}
              >
                <i className="bi bi-house me-2"></i>
                Về Trang Chủ
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default MemberCard;
